import {
  LoginRequest,
  VerifyOtpRequest,
  LoginResponse,
  ChangePasswordRequest,
  ResetPasswordRequest,
} from 'types/login'
import request from 'tools/request'

type loginHeaders = {
  factorId: string
}

export async function login(loginRequest: LoginRequest, headers: loginHeaders) {
  const data = await request
    .post<LoginResponse>(
      'clientportal/authentications/generate-token',
      loginRequest,
      {
        headers: headers,
      }
    )
    .then((r) => r.data)
  return data
}

export async function verifyOtp(payload: VerifyOtpRequest) {
  const data = await request
    .post<LoginResponse>('clientportal/authentications/login', payload)
    .then((r) => r.data)
  return data
}

export const resendOtp = async (email: string) => {
  const url = `clientportal/authentications/resend-otp-code`
  return await request.post(url, {
    username: email,
  })
}

export const resetPassword = async (email: string) => {
  const url = `clientportal/authentications/reset-password-link?email=${encodeURIComponent(
    email
  )}`
  return await request.post(url)
}

export const sentResetPasswordLink = async (
  payload: ResetPasswordRequest,
  headers: loginHeaders
) => {
  const data = await request.post(
    `clientportal/authentications/reset-password-link`,
    payload,
    {
      headers: headers,
    }
  )
  return data
}

export const changePassword = async (payload: ChangePasswordRequest) => {
  return await request.post(
    `clientportal/authentications/update-password`,
    payload
  )
}
